module.exports = __webpack_public_path__ + "media/images/landings/promotion_2/trouble_img_03-1e59008a862d4862956506760b93798d.jpg";